export default "__VITE_ASSET__BG_vzwE1__"